// Géométrie des ascenseurs du viewer en mode taille réelle (1:1).
//
// En 1:1 l'agent ne capture qu'une fenêtre `view` du bureau `full` (cf.
// `sourceRect` dans panels/video.tsx). Les ascenseurs affichent la position de
// cette fenêtre dans le bureau et permettent de la déplacer. Logique pure ici
// pour rester testable hors DOM.

export type ViewRect = { x: number; y: number; w: number; h: number };
export type DesktopSize = { w: number; h: number };

/** Position et taille du curseur, en fraction [0,1] de la piste. */
export type Thumb = { pos: number; size: number };

/**
 * Curseur d'ascenseur pour un axe, ou `null` s'il n'y a rien à faire défiler
 * (fenêtre aussi large que le bureau, ou dimensions inexploitables).
 */
export function thumbGeometry(view: ViewRect, full: DesktopSize, axis: "x" | "y"): Thumb | null {
  const span = axis === "x" ? full.w : full.h;
  const win = axis === "x" ? view.w : view.h;
  const off = axis === "x" ? view.x : view.y;
  if (!(span > 0) || !(win > 0)) return null;
  if (win >= span) return null;
  const size = win / span;
  // `off` peut dépasser transitoirement pendant un pan local non committé.
  const maxOff = span - win;
  const pos = Math.min(1 - size, Math.max(0, Math.min(maxOff, off) / span));
  return { pos, size };
}

/**
 * Convertit un déplacement du curseur en pixels CSS de piste vers un delta en
 * pixels bureau. `trackPx` = longueur de la piste à l'écran, `fullPx` = taille
 * du bureau sur cet axe.
 */
export function trackDeltaToDesktop(deltaTrackPx: number, trackPx: number, fullPx: number): number {
  if (!(trackPx > 0) || !(fullPx > 0)) return 0;
  return Math.round((deltaTrackPx / trackPx) * fullPx);
}
